import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { v4 as uuidv4 } from 'uuid';

export default function TradeLog({ log, setLog }) {
  const [newTime, setNewTime] = useState('');
  const [newNote, setNewNote] = useState('');

  const handleAdd = (e) => {
    e.preventDefault();
    if (!newTime || !newNote) return;
    setLog([...log, { id: uuidv4(), time: newTime, note: newNote }]);
    setNewTime(''); setNewNote('');
  };

  const removeEntry = (id) => setLog(log.filter(l => l.id !== id));

  return (
    <div className="mt-6">
      <h3 className="text-sm font-medium text-app-muted mb-3 flex items-center gap-2"><FiIcons.FiList /> Trade Log</h3>
      <div className="space-y-2 mb-3">
        {log.map(entry => (
          <div key={entry.id} className="flex gap-3 items-start group text-sm bg-app-surface/50 p-2 rounded border border-app-border/50">
            <span className="font-mono text-app-accent shrink-0">{entry.time}</span>
            <span className="flex-1 text-app-text">{entry.note}</span>
            <button onClick={() => removeEntry(entry.id)} className="text-app-muted hover:text-app-red opacity-0 group-hover:opacity-100 transition-opacity"><FiIcons.FiTrash2 size={14}/></button>
          </div>
        ))}
        {log.length === 0 && <p className="text-sm text-app-muted italic">No log entries yet.</p>}
      </div>
      <form onSubmit={handleAdd} className="flex gap-2">
        <input type="time" value={newTime} onChange={e => setNewTime(e.target.value)} className="w-32 text-sm" required />
        <input type="text" value={newNote} onChange={e => setNewNote(e.target.value)} placeholder="Entry note..." className="flex-1 text-sm" required />
        <button type="submit" className="px-3 py-1.5 bg-app-surface border border-app-border rounded hover:border-app-accent text-sm"><FiIcons.FiPlus /></button>
      </form>
    </div>
  );
}